import _ from 'lodash';
import { CheckIcon } from '@heroicons/react/outline';

const Avatar = ({
  title,
  isModerator = false,
}: {
  title: string;
  isModerator?: boolean;
}): JSX.Element => {
  const matches = title.split(' ').map(word => word[0]);
  let slag = '';
  if (_.isArray(matches)) {
    if (matches.length > 2 && isModerator) {
      slag = `${matches[matches.length - 3]}${matches[matches.length - 2]}${
        matches[matches.length - 1]
      }`;
    } else if (matches.length > 1) {
      slag = `${matches[matches.length - 2]}${matches[matches.length - 1]}`;
    } else if (matches.length > 0) {
      slag = `${matches[matches.length - 1]}`;
    }
  }
  return (
    <div className="relative flex justify-center items-center w-full h-full rounded-full bg-gray-200 text-gray-500 text-xs font-medium uppercase">
      {slag.includes('undefined') ? '' : slag}
      {isModerator ? (
        <span className="absolute top-0 right-0 w-3 h-3 flex justify-center items-center bg-blue-500 rounded-full">
          <CheckIcon className="w-2 h-2 text-white" />
        </span>
      ) : null}
    </div>
  );
};

export default Avatar;
